import { render, staticRenderFns } from "./ConfirmarMarcacao.vue?vue&type=template&id=875509fa&"
import script from "./ConfirmarMarcacao.vue?vue&type=script&lang=js&"
export * from "./ConfirmarMarcacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports